if(!customElements.get('search-drawer')) {
  customElements.define(
    "search-drawer",
    class SearchDrawer extends Drawer {
      constructor() {
        super();
        this.recommendationByHistory = this.querySelector('recommendation-by-history');
      }

      show(opener) {
        super.show(opener);
        this.recommendationByHistory?.showContent();
        
        // 延迟聚焦输入框，避免 trapFocus 冲突
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const input = this.querySelector('input[type="search"], input[name="q"]');
            if (input && this.hasAttribute('open')) input.focus();
          });
        });
      }

      hide() {
        super.hide();
        this.recommendationByHistory?.abortFetch();
      }
    },
  );
}

